import { AgTechButton } from "@agtech/web/components/Buttons/AgTechButtons";
import AgTechCard from "@agtech/web/components/Cards/AgTechCard";
import AgTechHeaderDetail from "@agtech/web/components/Headers/AgTechHeaderDetail";
import AgTechIconBadge from "@agtech/web/components/Icons/AgTechIconBadge";

export type ReportCardProps = {
    reportName: string,
    reportDescription: string,
    reportIcon: string,
    reportDownloadAction: () => Promise<any>
}

const ReportCard = (props: ReportCardProps) => {
    return (
        <AgTechCard
            content={{
                header: () => (
                    <AgTechHeaderDetail
                        header={props.reportName}
                        settings={{
                            classes: 'flex items-center',
                            header: {
                                classes: '!text-more'
                            }
                        }}
                    >
                        <AgTechIconBadge
                            icon={props.reportIcon}
                            size={30}
                            iconClasses="text-sm"
                        />
                    </AgTechHeaderDetail>
                ),
                footer: () => (
                    <AgTechButton
                        text='Download'
                        icon='fas fa-download'
                        action={async e => await e.actions.executeWithVisual(
                            props.reportDownloadAction,
                            { message: 'Downloading report: ' + props.reportName, delay: 1000 },
                        )}
                        classes='ml-auto button-highlight'
                    />
                )
            }}
            structure={{
                height: 180
            }}
        >
            <h1 className='font-size-standard font-color-secondary'>
                {props.reportDescription}
            </h1>
        </AgTechCard>
    )
}

export default ReportCard;